import {RecordTableColumnParams} from "../../../types/records-table.types";
import {SortOrder} from "../../../types/utility.types";
import {RecordTableAction} from "../../../types/record-table-action.types";

export function reorderColumnsAccordingToOrderProperty(columnsParams: Array<RecordTableColumnParams>):  Array<RecordTableColumnParams> {
  return [
    ...columnsParams.filter((columnParams: RecordTableColumnParams) => columnParams.sticky).sort((a: RecordTableColumnParams, b: RecordTableColumnParams) => a.order - b.order),
    ...columnsParams.filter((columnParams: RecordTableColumnParams) => !columnParams.sticky).sort((a: RecordTableColumnParams, b: RecordTableColumnParams) => a.order - b.order)
  ]
}

export const sortOrderMap: { [key in SortOrder]: SortOrder } = {
  'desc': 'asc',
  'asc': 'none',
  'none': 'desc'
};

export const totalMap: { [key in string]: string | null } = {
  'AVG': 'x̄',
  'SUM': '∑',
  'MIN': '⌊',
  'MAX': '⌈',
  'CUSTOM': 'xᵢ'
}

export const headerFooterHeight: string = '136px';

export const headerFooterHeightWithoutGroup: string = '96px';

export const shouldReloadTable = (action: RecordTableAction): boolean =>
  action !== 'DOWNLOAD_EXCEL' &&
  action !== 'DOWNLOAD_OLD_FORMAT_EXCEL' &&
  action !== 'LINE_CHART' &&
  action !== 'ADD_ADVERTISEMENT_PACKAGE';

export const availableTableActions = new Set<RecordTableAction>(['DELETE_ROW', 'CHANGE_USER_PASSWORD', 'BLOGGER_DEDUPLICATION']);
